import { useNavigate } from "react-router-dom";
import { XCircle } from "lucide-react";
import { Logo } from "@/components/Common";

export default function PaymentCancel() {
  const navigate = useNavigate();
  return (
    <div className="min-h-screen grid place-items-center px-4">
      <div className="w-full max-w-md rounded-3xl border border-[hsl(var(--border))] bg-[hsl(var(--card))] p-8 text-center" data-testid="payment-cancel-page">
        <div className="flex justify-center mb-6"><Logo /></div>
        <div className="h-16 w-16 mx-auto grid place-items-center rounded-full bg-[hsl(var(--muted))] text-[hsl(var(--muted-foreground))]"><XCircle size={34} /></div>
        <h1 className="mt-5 font-display text-2xl font-semibold">Checkout cancelled</h1>
        <p className="mt-2 text-[hsl(var(--muted-foreground))]">No charge was made. You can upgrade any time to keep your tribute forever.</p>
        <button data-testid="payment-cancel-back" onClick={() => navigate(-1)}
          className="mt-6 w-full px-6 py-3.5 rounded-xl bg-[hsl(var(--primary))] text-[hsl(var(--primary-foreground))] font-semibold hover:opacity-90 transition-opacity">
          Back
        </button>
      </div>
    </div>
  );
}
